import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { siteConfig } from "../siteConfig";

const ServiceCard = ({ service }) => (
  <Link
    to={`/services/${service.slug}`}
    className="group block rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 bg-white"
  >
    <div className="aspect-[4/3] overflow-hidden">
      <img
        src={service.image}
        alt={service.name}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
      />
    </div>
    <div className="p-5">
      <h3
        className="font-display font-black text-lg mb-2 group-hover:opacity-70 transition-colors"
        style={{ color: siteConfig.colors.dark }}
      >
        {service.name}
      </h3>
      <p className="text-gray-500 text-sm leading-relaxed mb-4">{service.shortDescription}</p>
      <span
        className="inline-flex items-center gap-1.5 text-sm font-semibold"
        style={{ color: siteConfig.colors.primary }}
      >
        Learn More <ArrowRight className="w-4 h-4" />
      </span>
    </div>
  </Link>
);

export default ServiceCard;
